import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d1a9b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scrollable-widget" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-lg" }, "Select program to display courses", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "block mb-1 ml-2 text-left text-xl font-bold underline" }
const _hoisted_6 = { class: "w-full rounded-lg overflow-hidden" }
const _hoisted_7 = { class: "bg-gray-400" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "px-4 py-2",
  style: {"text-align":"left"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "px-4 py-2 text-left",
  style: {"text-align":"left"}
}, " Kruskod ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "px-4 py-2 text-left",
  style: {"text-align":"left"}
}, " Kursnamn ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "px-4 py-2 text-left",
  style: {"text-align":"left"}
}, "Hp", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "px-4 py-2 text-left",
  style: {"text-align":"left"}
}, "Nivå", -1))
const _hoisted_13 = {
  key: 0,
  class: "px-4 py-2 text-left",
  style: {"text-align":"left"}
}
const _hoisted_14 = { class: "flex items-center justify-center h-full" }
const _hoisted_15 = ["checked", "onChange"]
const _hoisted_16 = { style: {"text-align":"left"} }
const _hoisted_17 = { style: {"text-align":"left"} }
const _hoisted_18 = { style: {"text-align":"left"} }
const _hoisted_19 = { style: {"text-align":"left"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-center mb-1" }
const _hoisted_22 = { class: "flex justify-center space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LPWidget = _resolveComponent("LPWidget")!
  const _component_gridCol = _resolveComponent("gridCol")!
  const _component_gridRow = _resolveComponent("gridRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isEmptyTableData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableData, (courseList, category) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mb-8",
            key: category
          }, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(category), 1),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  (category != 'Exjobb')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_13, " Läsperiod "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList, (course, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
              'bg-white': index % 2 === 0,
              'bg-gray-200': index % 2 !== 0,
            })
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: course.selected,
                          onChange: ($event: any) => (_ctx.atChecked(course, $event)),
                          class: "accent-blue-500 h-5 w-5"
                        }, null, 40, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(course.courseCode), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(course.name_sv), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(course.credits), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(course.cycle), 1),
                    _createElementVNode("td", null, [
                      (course.groupId != 'exjobb')
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                            _createVNode(_component_gridRow, {
                              container: "",
                              gutter: 6,
                              class: "px-4 py-2"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(course.timePlans.lps, (lp, pos) => {
                                  return (_openBlock(), _createBlock(_component_gridCol, {
                                    key: pos,
                                    lg: 3
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_LPWidget, {
                                        lps: lp,
                                        index: pos
                                      }, null, 8, ["lps", "index"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ]))
        }), 128)),
    (_ctx.showPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "popup flex flex-col items-center justify-center p-4",
          style: _normalizeStyle({ top: _ctx.popupTop + 'px', left: _ctx.popupLeft + 'px' }),
          ref: "popupBox"
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", null, "Choose year to add " + _toDisplayString(_ctx.selectedCourse?.courseCode) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn-submit",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePopupAction(true, 'År 4')))
            }, " År 4 "),
            _createElementVNode("button", {
              class: "btn-submit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePopupAction(true, 'År 5')))
            }, " År 5 ")
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}